import { Box, Button, Link as MuiLink } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Lock } from '@mui/icons-material';
import { BodyText } from './BodyText';
import { calculateCleanupDate } from '@/utils/trial';

const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '100%',
  backgroundColor: theme.palette.background.default,
  padding: '32px',
}));

const Card = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: '8px',
  padding: '48px',
  maxWidth: '500px',
  textAlign: 'center',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '24px',
}));

const IconWrapper = styled(Box)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '64px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const Title = styled(BodyText)(({ theme }) => ({
  fontSize: '24px',
  fontWeight: 600,
  color: theme.palette.text.primary,
}));

const Message = styled(BodyText)(({ theme }) => ({
  fontSize: '16px',
  color: theme.palette.text.secondary,
  lineHeight: '1.5',
}));

const ContactButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.common.white,
  padding: '12px 32px',
  fontSize: '16px',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: theme.palette.secondary.dark,
  },
}));

export const TrialExpiredPage = ({ expirationDate }: { expirationDate?: string }) => {
  const cleanupDate = expirationDate ? calculateCleanupDate(expirationDate) : undefined;
  const formattedExpirationDate = expirationDate ? new Date(expirationDate).toLocaleDateString() : undefined;
  const formattedCleanupDate = cleanupDate ? cleanupDate.toLocaleDateString() : undefined;

  return (
    <Container>
      <Card>
        <IconWrapper>
          <Lock fontSize='inherit' />
        </IconWrapper>
        <Title>Your Trial ended on {formattedExpirationDate}</Title>
        <Message>
          Your data is scheduled to be deleted on {formattedCleanupDate}. To continue using Physna and prevent data
          deletion, please contact our sales team to discuss subscription options.
        </Message>
        <MuiLink href={`mailto:${import.meta.env.VITE_SUPPORT_EMAIL || 'support@physna.com'}`} underline='none'>
          <ContactButton variant='contained'>Contact</ContactButton>
        </MuiLink>
      </Card>
    </Container>
  );
};
